import React, { useCallback } from 'react';
import {    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    Edit, SimpleForm, TextInput,SelectInput,
    DateInput, BooleanInput, NumberInput,ReferenceInput,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { makeStyles } from '@material-ui/core/styles';
import { CreateToolbar } from "../../CreateToolbar";

const useStyles = makeStyles(theme => ({
    subjectid:{
        display:'inline-block'
    }, 
    title: {
        display:'inline-block',
        marginLeft: '20px',
        width:'300px'
    }
}));

export const LeaveTypesEdit = props => (
    <Edit {...props} title="Leave Types" redirect={false} successMessage="Leave Type Updated" undoable={false}>
            <SimpleForm redirect="list"   toolbar={<CreateToolbar {...props} />}
            variant="outlined">
            <ReferenceInput source="leaveCategoryId" reference="leave-categories">
                <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput source="name" label="Name"/>
            <TextInput source="description" label="Description"/>
            </SimpleForm>
        </Edit>
    );
